import React from "react";
import styled from "styled-components";
import { Trigger } from "@radix-ui/react-accordion";
const StyledAccordionTrigger = ({ children, ...props }) => {
    return (React.createElement(Trigger, { ...props },
        React.createElement("span", { className: "trigger-text" }, children),
        " ",
        React.createElement("span", { className: "trigger-icon", "aria-hidden": true })));
};
StyledAccordionTrigger.defaultProps = {
    "data-testid": "accordion-trigger",
};
export const AccordionTrigger = styled(StyledAccordionTrigger) `
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1;
  align-items: center;
  text-align: left;
`;
//# sourceMappingURL=AccordionTrigger.js.map